import { useQuery } from "react-query";
import { useClient } from "hooks";

export const useConnectedOrganisationsQuery = (config) => {
  const client = useClient();

  return useQuery({
    queryKey: ["connected_organisations"],
    queryFn: async () => client.get("connected_organisations").get("data"),
    ...config,
  });
};
